import { onMessage } from "firebase/messaging";
import { messaging } from "./config/firebaseConfig";
import { NOTIFICATION_PERMISSIONS } from "./utils/constants";

export const setupOnMessageListener = (onNotification) => {
  if (!messaging) {
    console.warn("Firebase Cloud Messaging is not available");
    return;
  }
  onMessage(messaging, (payload) => {
    if (onNotification) {
      onNotification(payload.notification);
    }

    if (Notification.permission === NOTIFICATION_PERMISSIONS.GRANTED) {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.icon,
      });
    }
  });
};
